import { Injectable } from "@angular/core";
import { CoreCOMService } from "./com.service";
import { customConfig } from "../../custom/custom-config";
import { environment } from "../../../environments/environment";
import { ContentType, YourAPPProductType } from "../shared/contentTypes";

@Injectable({
  providedIn: "root"
})
export class EMenuService {
  private _isActive: boolean;

  constructor(private _coreCOMService: CoreCOMService) {
    const me = this;
    me._isActive = environment.producttype === YourAPPProductType.emenu;

    if (this.isActive) {
      // Force eMenuTitle;
      const configuredEMenuTitle = customConfig["eMenuTitle"];
      customConfig.title = (configuredEMenuTitle) ? configuredEMenuTitle : "eMENU";
    }
  }

  /**
   * Returns whether eMENU is active
   */
  public get isActive(): boolean {
    return this._isActive;
  }
}
